<template>
  <CardContainer :cardTitle="title" :isEmptyData="isLoaded && dataSource != null && dataSource.dataset.length === 0" :titleId="'scatter-chart-' + index" :participantName="dataParticipantName" :primaryColor="primaryColor" :choosenAnswers="choosenAnswers">
    <div slot="body">
      <fusioncharts type="scatter" width="100%" height="350" dataFormat="json" :dataSource="dataSource"> </fusioncharts>
    </div>
  </CardContainer>
</template>
<script>
import _ from "lodash";
import CardContainer from "./card-container";
import { generateScatterChartCard } from "../../services/utils";
import { optionsScatterChart } from "../../services/chart-config";

export default {
  props: {
    index: [String, Number],
    title: { type: String, default: "Default Title" },
    isLoaded: { type: Boolean, default: false },
    dataSources: [Array, null],
    primaryColor: { type: String, default: "" },
    dataParticipantName: { type: String, default: "" }
  },
  components: {
    CardContainer
  },
  data() {
    return {
      dataSource: null,
      choosenAnswers: []
    };
  },
  methods: {
    processVisualization() {
      const clonedOptions = _.cloneDeep(optionsScatterChart);
      const { categories, datasets, choosenAnswers } = generateScatterChartCard(this.dataSources, this.primaryColor, this.dataParticipantName);
      this.choosenAnswers = choosenAnswers;
      clonedOptions.categories.push({ category: categories });
      clonedOptions.dataset = [...datasets];

      this.dataSource = clonedOptions;
    }
  },
  mounted() {
    this.processVisualization();
  }
};
</script>
